module.exports = __webpack_public_path__ + "static/media/metronome.b9ea6224.wav";